import { render } from "./PersonalInfoScreen.vue?vue&type=template&id=438e639c&scoped=true"
import script from "./PersonalInfoScreen.vue?vue&type=script&lang=js"
export * from "./PersonalInfoScreen.vue?vue&type=script&lang=js"

import "./PersonalInfoScreen.vue?vue&type=style&index=0&id=438e639c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438e639c"]])

export default __exports__